// 메인 스레드(API)와 워커가 반드시 같은 빌드를 가리켜야 "API version does not match Worker version"
// 류의 렌더링 실패가 생기지 않는다. 그래서 둘 다 pdfjs-dist/build/pdf.mjs 기준으로 명시적으로 import 한다.
import * as pdfjsLib from "pdfjs-dist/build/pdf.mjs";
import type { PDFDocumentProxy, PDFPageProxy, RenderTask } from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

/** Load a PDF document from a File object. */
export async function loadPdfFromFile(file: File): Promise<PDFDocumentProxy> {
  const buffer = await file.arrayBuffer();
  const loadingTask = pdfjsLib.getDocument({ data: new Uint8Array(buffer) });
  try {
    return await loadingTask.promise;
  } catch (err) {
    console.error("[pdf] 문서 로드 실패", err);
    throw err;
  }
}

/**
 * Render a single PDF page onto a canvas at the given scale.
 * Returns the render task so callers can cancel in-flight renders.
 */
export function renderPageToCanvas(
  page: PDFPageProxy,
  canvas: HTMLCanvasElement,
  scale: number
): RenderTask {
  const viewport = page.getViewport({ scale });
  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Canvas 2D context is not available.");
  }
  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);

  const params = {
    canvasContext: context,
    canvas,
    viewport,
  } as unknown as Parameters<typeof page.render>[0];

  return page.render(params);
}

export type { PDFDocumentProxy, PDFPageProxy, RenderTask };